import 'mdn-polyfills/NodeList.prototype.forEach';
import ContactForm from './components/contactForm';
import FormBlockForm from './components/formBlockForm';
import NewsletterForm from './components/newsletterForm';

document.addEventListener('DOMContentLoaded', () => {
	ContactForm.init();
	FormBlockForm.init();
	NewsletterForm.init();
});
